// Function to download a file
// export async function downloadFile(url, filename) {
//   try {
//     // Fetch the file
//     const response = await fetch(url);

//     // Check if the request was successful
//     if (response.status === 200) {
//       throw new Error(`Unable to download file. HTTP status: ${response.status}`);
//     }

//     // Get the Blob data
//     const blob = await response.blob();

//     // Create a download link
//     const downloadLink = document.createElement('a');
//     downloadLink.href = URL.createObjectURL(blob);
//     downloadLink.download = filename;

//     // Trigger the download
//     document.body.appendChild(downloadLink);
//     downloadLink.click();

//     // Clean up
//     setTimeout(() => {
//       URL.revokeObjectURL(downloadLink.href);
//       document.body.removeChild(downloadLink);
//     }, 100);
//   } catch (error) {
//     console.error('Error downloading the file:', error.message);
//   }
// }

export function convertToPersianNumber(englishNumber) {
  let persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  let persianNumber = '';

  for (let i = 0; i < englishNumber.length; i++) {
    const char = englishNumber.charAt(i);
    if (char >= 0 && char <= 9) {
      persianNumber += persianNumbers[parseInt(char)];
    } else {
      persianNumber += char;
    }
  }

  return persianNumber;
}
export const downloadFile = async (url, name, type, setDownloadLoader) => {
  if (url) {
    setDownloadLoader(true);
    fetch(url)
      .then(response => {
        response.blob().then(blob => {
          setDownloadLoader(false);
          var FileSaver = require('file-saver');
          var blo1b = new File([blob], name, { type: type });
          FileSaver.saveAs(blo1b, name);
        });
      })
      .catch(err => {
        setDownloadLoader(false);
      });
  }
};

export const URLToFile = async (url, fileName) => {
  // const fileName = url.substring(url.lastIndexOf('/') + 1)

  return await fetch(url)
    .then(response => response.blob())
    .then(
      blob =>
        new File([blob], `${fileName}`, {
          type: blob.type,
        })
    )
    .then(file => {
      return file;
    });
};

export const dateFormat = d => {
  const pad = int => {
    let a = String(int).length == 1 ? `0${int}` : int;
    return a;
  };
  let date = new Date(d).getDate();
  let month = new Date(d).getMonth() + 1;
  let year = new Date(d).getFullYear();
  return `${pad(date)}-${pad(month)}-${year}`;
};

export const catTree = data => {
  return data.categories.map(c => c.category_name).join(' > ');
  // let a = `${addSubCat ? `${addSubCat}` : ''}${subCat ? ` < ${subCat}` : ''}${cat ? ` < ${cat}` : ''}${parentCat ? ` < ${parentCat}  ` : ''}`
};

export const catTreeWithfahrast = data => {
  return data.categories.map(c => c.category_name).join(' > ');
  // فهرست › عنوان ١ › عنوان ٢ › عنوان ٣

  // let a = `${addSubCat ? `${addSubCat}` : ''}${subCat ? ` < ${subCat}` : ''}${cat ? ` < ${cat}` : ''}${parentCat ? ` < ${parentCat}  ` : ''}`
};

// "2023-08-16T08:24:02.175Z"
export const dateFormatHadith = d => {
  const pad = int => {
    let a = String(int).length == 1 ? `0${int}` : int;
    return a;
  };
  let date = new Date(d).getDate();
  let month = new Date(d).getMonth() + 1;
  let year = new Date(d).getFullYear();
  return `${year}-${pad(month)}-${pad(date)}`;
};

export const monthArr = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function getLast10Years() {
  let currentYear = new Date().getFullYear();
  const last10Years = [];

  for (let i = 0; i < 10; i++) {
    last10Years.push(currentYear - i);
  }

  return last10Years;
}

export const pad = int => {
  let a = String(int).length == 1 ? `0${int}` : int;
  return a;
};
const persianDaysOfWeek = [
  'یک‌شنبه', // Sunday
  'دوشنبه', // Monday
  'سه‌شنبه', // Tuesday
  'چهارشنبه', // Wednesday
  'پنج‌شنبه', // Thursday
  'جمعه', // Friday
  'شنبه', // Saturday
];

export function getPersianDayOfWeek(date) {
  let dayIndex = new Date(date).getDay();
  if (dayIndex >= 0 && dayIndex < persianDaysOfWeek.length) {
    return persianDaysOfWeek[dayIndex];
  } else {
    return 'Invalid day index';
  }
}
export const persianMonthNames = [
  'ژانویه',
  'فوریه',
  'مارس',
  'آوریل',
  'مه',
  'ژوئن',
  'ژوئیه',
  'اوت',
  'سپتامبر',
  'اکتبر',
  'نوامبر',
  'دسامبر',
];

export const persianDate = d => {
  let date = new Date(d).getDate();
  let month = persianMonthNames[new Date(d).getMonth()];
  let year = new Date(d).getFullYear();
  return `${date} ${month} ${year}`;
};

export const lineBreak = text => {
  if (!text) return;

  const updatedStr = text.split('@@').join(' DouBleBreAk ').split('@').join(' SinGleBreAk ');

  if (!updatedStr.split(' DouBleBreAk ').length) return null;

  return updatedStr.split(' DouBleBreAk ').map((a, i) => {
    if (!a.split(' SinGleBreAk ').length) return null;

    if (!(a.split(' SinGleBreAk ').length > 1))
      return (
        <>
          {a}
          <br />
          <br />
        </>
      );

    return a.split(' SinGleBreAk ').map((b, j) => {
      return (
        <>
          {b}
          <br />
        </>
      );
    });
  });
};

console.log(lineBreak('Ahmed'));

// export const reorder = (list, startIndex, endIndex) => {
//   if (list.length === 0) return list;
//   const result = [...list];
//   const [removed] = result.splice(startIndex, 1);
//   result.splice (endIndex, 0, removed);
//   return result;
//   };
//                                 2        1
export const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const getOrder = (sortedElements, elements) => {
  sortedElements
    .filter(_el => {
      const el = elements.find(el => el.id === _el.id);
      return _el.index !== el.index;
    })
    .map(el => [el.id, el.index]);
};
